import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from "./Home";
import Post from "./Post";
import SinglePost from "./SinglePost";
import ContactForm from "./ContactForm";
import NotFound from "./NotFound";
import NavBar from "./NavBar";

const App = () => (
  <BrowserRouter>
    <NavBar />
    <Switch>
      <Route path="/" component={Home} exact />
      <Route path="/post/:slug" component={SinglePost} />
      <Route path="/post" component={Post} />
      <Route path="/contact" component={ContactForm} />
      <Route component={NotFound} />
    </Switch>
  </BrowserRouter>
);

export default App;
